import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

export interface IDenizBankPaymentFacilitatorRequestType {
    merchantId: any;
}

async function denizBankPaymentFacilitatorRequest(
    data: IDenizBankPaymentFacilitatorRequestType
): Promise<any> {
    try {
        return (await axiosInstance.post("/Merchant/DenizBankCreatePaymentFacilitator/" + data.merchantId)).data;
    } catch (ex) {
        throw ((ex as AxiosError).response?.data as any).error;
    }
}

export function useDenizBankPaymentFacilitatorRequest() {
    return useMutation<any, Error, IDenizBankPaymentFacilitatorRequestType>(
        (variables) => denizBankPaymentFacilitatorRequest(variables)
    );
}
